/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */

import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import WorkOutlineIcon from '@mui/icons-material/WorkOutline'
import { Box, Button, Typography } from '@mui/material'
import { JourneyType } from 'app/constants/Booking/BookingConstants'
import DisplayPrice, {
  displayPriceFunction,
} from 'components/Common/DisplayValues/DisplayPrice'
import Counter from 'components/RouteWizard/Counter'
import { useWizard } from 'components/RouteWizard/Wizard'
import useBooking from 'hooks/useBooking'
import useClient from 'hooks/useClient'
import useTravelPolicy from 'hooks/useTravelPolicy'
import React from 'react'
import IconChaffuer from '../../../../assets/icon/icon-chaffeur.svg'
import IconGreenBadge from '../../../../assets/icon/icon-green-badge.svg'
import IconTime from '../../../../assets/icon/icon-time.svg'
import VehicleDetailsModal from './VehicleDetailsModal/VehicleDetailsModal'

export interface AlternativeOptionProps {
  option: {
    supplierQuoteReference: string
    supplierName: string
    termsAndConditions: string
    vehicleTypeName: string
    vehicleDetails: any
    estimatedArrivalTime: number
    estimatedPrice: {
      price: number
      currency: string
      total: number
      vat: number
    }
    services: Array<any>
    estimatedTotal: {
      total: number
      price: number
      currency: string
      vat: number
    }
    isDestinationLogicQuote: boolean
    isPreferredSupplier: boolean
  }
  optionTypeName: string
  price: number
}
export interface QuotesProp {
  estimatedPriceCurrency: string
  eta: number
  inboundSupplierQuoteReference: any
  isAvailableReturnVehicle: boolean
  isDestinationLogicQuote: boolean
  price: {
    price: number
    total: number
    currency: string
    vat: number
  }
  inboundPrice: {
    price: number
    total: number
    currency: string
    vat: number
  }
  supplierLogo: any
  supplierName: string
  supplierQuoteReference: string
  isPreferredSupplier: boolean
  vehicleTypeName: string
  vehicleDetails: any
  alternativeOptions: Array<AlternativeOptionProps>
  inboundAlternativeOptions: Array<AlternativeOptionProps>
  isTrackable?: boolean
}

export type FlexibleOption = Omit<AlternativeOptionProps['option'], 'price'> & {
  price: QuotesProp['price']
  estimatedPriceCurrency?: undefined
  inboundSupplierQuoteReference?: undefined
}

export interface HandleBookCar {
  data: any
  vehicleDetails: any
}

type QuotesTitleProps = {
  title?: string
  example?: string
  cardist?: string
  image?: string
  seats?: number
  luggage?: number
  quotes?: Array<QuotesProp>
  isImmediateJourney: boolean
  selectedVehicles: any
  selectMultiple: boolean
  canSelectMoreCars: boolean
  setSelectedVehicles: any
  returnVehicles: any
  client?: any
  handleBookCar: (value: HandleBookCar) => void
}

const QuotesTitle = ({
  title,
  example,
  cardist,
  image,
  seats,
  luggage,
  quotes,
  isImmediateJourney,
  selectedVehicles,
  setSelectedVehicles,
  selectMultiple,
  returnVehicles,
  canSelectMoreCars,
  client,
  handleBookCar,
}: QuotesTitleProps) => {
  const [numOfVehicle, setNumOfVehicle] = React.useState<number>(0)
  const [openModal, setOpenModal] = React.useState<boolean>(false)
  const { data } = useWizard()
  const { displayVATPrice } = useClient(data.account.clientId)
  console.log('>>>>', data)
  const findIfPreffered = quotes?.filter((v) => v.isPreferredSupplier)
  const getPriceObject = (
    findIfPreffered?.length ? findIfPreffered : quotes
  )?.reduce((acc, current) => {
    const currentPrice = returnVehicles ? current?.inboundPrice : current?.price
    const accPrice = returnVehicles ? acc?.inboundPrice : acc?.price
    return currentPrice < accPrice ? current : acc
  })

  let lowestPriceObject = {
    ...getPriceObject,
    price: returnVehicles
      ? getPriceObject?.inboundPrice
      : getPriceObject?.price,
  }

  lowestPriceObject =
    lowestPriceObject?.price && lowestPriceObject?.estimatedPriceCurrency
      ? {
          ...lowestPriceObject,
          price: {
            ...lowestPriceObject?.price,
            currency: lowestPriceObject?.estimatedPriceCurrency,
          },
        }
      : { ...lowestPriceObject }

  const forAlternativeOptions = returnVehicles
    ? lowestPriceObject?.inboundAlternativeOptions
    : lowestPriceObject?.alternativeOptions
  const findFlexibleAlternative =
    lowestPriceObject?.isDestinationLogicQuote &&
    !lowestPriceObject?.isPreferredSupplier &&
    forAlternativeOptions?.[0]?.optionTypeName === 'Local_Supplier'
      ? {
          ...forAlternativeOptions?.[0]?.option,
          price: displayVATPrice
            ? forAlternativeOptions?.[0]?.option?.estimatedTotal
            : forAlternativeOptions?.[0]?.option?.estimatedPrice,
        }
      : null

  const flexibleResult = findFlexibleAlternative?.vehicleTypeName
    ? [findFlexibleAlternative]
    : []

  const getFlexibleOption =
    (findIfPreffered?.length || 0) > 0
      ? []
      : lowestPriceObject?.isDestinationLogicQuote
      ? flexibleResult
      : []
  const findLowestPriceFlexible = getFlexibleOption?.length
    ? getFlexibleOption.reduce((acc, curr) => {
        return curr?.price?.price < acc?.price?.price ? curr : acc
      })
    : null
  const showLowestPrice = Number(
    displayPriceFunction(lowestPriceObject?.price, displayVATPrice)?.exactPrice,
  )
  const showFlexLowPrice = findLowestPriceFlexible?.price
    ? Number(
        displayPriceFunction(findLowestPriceFlexible.price, displayVATPrice)
          ?.exactPrice,
      )
    : 0
  const displayFlexible =
    showLowestPrice < showFlexLowPrice ? findLowestPriceFlexible : null

  const { isLoading: isLoadingBooking } = useBooking()
  const { precheckWizardBooking, buildPolicyDialogText, buildPolicyMessage } =
    useTravelPolicy()

  const selectedNumberVehicle = selectedVehicles
    ? Object.entries(selectedVehicles).reduce((acc: any, curr: any) => {
        const currentData = curr[1]
        acc += currentData?.quantity
        return acc
      }, 0)
    : 0

  const handleVehicleCounter = (type: 'positive' | 'negative') => {
    let newCount = 0

    if (
      type === 'positive' &&
      data?.account?.numberOfPassengers <= selectedNumberVehicle
    ) {
      return
    }

    setNumOfVehicle((prevValue) => {
      newCount = type === 'negative' ? prevValue - 1 : prevValue + 1
      let selectedVehiclesList = selectedVehicles

      setSelectedVehicles({
        ...selectedVehiclesList,
        [lowestPriceObject?.supplierQuoteReference || '']: {
          supplierQuoteReference: lowestPriceObject?.supplierQuoteReference,
          inboundSupplierQuoteReference:
            lowestPriceObject?.inboundSupplierQuoteReference,
          quantity: newCount,
          price: lowestPriceObject?.price,
          priceCurrency: lowestPriceObject?.estimatedPriceCurrency,
          seats: seats,
          title: title,
          counterValue: {
            title: title || '',
            example: example || '',
            image: image || '',
            seats: seats || 0,
            luggage: luggage || 0,
            quotes: lowestPriceObject,
          },
        },
      })
      return newCount
    })
  }

  return (
    <>
      <Box
        component="div"
        sx={{
          width: '100%',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          flexDirection: 'row',
          overflow: 'hidden',
          gap: '12px',
          padding: '12px',
        }}
      >
        <Box
          component="div"
          sx={{
            width: 'clamp(80px, 30%, 156px)',
            flexShrink: 0,
            aspectRatio: '156 / 182',
            backgroundColor: '#F7F7F7',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Box
            component="div"
            sx={{
              position: 'absolute',
              top: '0px',
              left: '0px',
              width: '40px',
              height: '40px',
              display: 'flex',
            }}
          >
            {title?.toLowerCase()?.includes('chauffer') && (
              <Box component="img" src={IconChaffuer} />
            )}
            {(title?.toLowerCase()?.includes('zero') ||
              title?.toLowerCase()?.includes('hybrid')) && (
              <Box component="img" src={IconGreenBadge} />
            )}
          </Box>
          {image && (
            <Box
              component="img"
              src={image}
              style={{
                height: 'auto',
                width: '100%',
              }}
            />
          )}
        </Box>
        <Box
          component="div"
          sx={{
            flexDirection: 'column',
            display: 'flex',
            justifyContent: 'space-between',
            flex: 1,
            minWidth: 0,
          }}
        >
          <Box
            component="div"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              justifyContent: 'space-between',
            }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '8px 12px',
                paddingBottom: 0,
                justifyContent: 'space-between',
                minWidth: 0,
                flex: 1,
              }}
            >
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {title && (
                  <Typography
                    component="p"
                    sx={(theme) => ({
                      color: theme.palette.brand.dark,
                      fontWeight: '600',
                      fontSize: 'clamp(14px, 2vw, 19px)',
                      lineHeight: 1.2,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    })}
                  >
                    {title}
                  </Typography>
                )}
                {example && (
                  <Typography
                    component="p"
                    sx={(theme) => ({
                      color: theme.palette.brand.dark,
                      fontWeight: '300',
                      fontSize: '17px',
                      lineHeight: '21px',
                      marginTop: '8px',
                    })}
                  >
                    {example}
                  </Typography>
                )}
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '12px 0',
                  }}
                >
                  <Box
                    component="div"
                    sx={{
                      display: isImmediateJourney ? 'flex' : 'none',
                      gap: '6px',
                      height: 'max-content',
                      alignItems: 'center',
                      visibility: isImmediateJourney ? 'visible' : 'hidden',
                    }}
                  >
                    <Box
                      component="img"
                      src={IconTime}
                      alt="info"
                      sx={{
                        marginLeft: '4px',
                        width: '24px',
                        height: '24px',
                      }}
                    />
                    <Typography
                      component="p"
                      sx={() => ({
                        color: '#002EA5',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '16px',
                        height: 'max-content',
                      })}
                    >
                      {`ETA ${
                        lowestPriceObject?.eta == 99
                          ? 'unavailable'
                          : `${lowestPriceObject?.eta} mins`
                      }`}
                    </Typography>
                  </Box>
                  {seats && (
                    <Box
                      component="div"
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        fontWeight: 'normal',
                        alignItems: 'center',
                        gap: '5px',
                        alignSelf: 'flex-end',
                      }}
                    >
                      <PeopleOutlineIcon />
                      <span>{seats}</span>
                    </Box>
                  )}
                  {luggage && (
                    <Box
                      component="div"
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        fontWeight: 'normal',
                        alignItems: 'center',
                        gap: '5px',
                        alignSelf: 'flex-end',
                      }}
                    >
                      <WorkOutlineIcon />
                      <span>{luggage}</span>
                    </Box>
                  )}
                </Box>
              </Box>
              {lowestPriceObject?.isPreferredSupplier && (
                <>
                  {lowestPriceObject?.supplierLogo ? (
                    <Box
                      component="img"
                      src={lowestPriceObject?.supplierLogo}
                      alt="chevron"
                      sx={{
                        width: 'clamp(60px, 20%, 100px)',
                        maxHeight: '24px',
                        objectFit: 'contain',
                        alignSelf: 'flex-start',
                      }}
                    />
                  ) : (
                    <Typography
                      component="p"
                      sx={(theme) => ({
                        color: theme.palette.brand.dark,
                        fontWeight: '700',
                        fontSize: '14px',
                        lineHeight: '20px',
                        textTransform: 'uppercase',
                      })}
                    >
                      {lowestPriceObject?.supplierName}
                    </Typography>
                  )}
                </>
              )}
            </Box>
            <Box
              component="div"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'end',
                }}
              >
                <Typography
                  component="p"
                  sx={(theme) => ({
                    color: theme.palette.brand.dark,
                    fontWeight: '400',
                    fontSize: '14px',
                    lineHeight: '24px',
                  })}
                >
                  STARTING AT
                </Typography>
                <Typography
                  component="p"
                  sx={(theme) => ({
                    color: theme.palette.brand.dark,
                    fontWeight: '600',
                    fontSize: 'clamp(18px, 3vw, 28px)',
                    lineHeight: 1.15,
                    marginTop: '4px',
                    whiteSpace: 'nowrap',
                  })}
                >
                  {DisplayPrice({
                    VATTotalPrice: lowestPriceObject?.price || undefined,
                    displayVATPrice: displayVATPrice,
                  })}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            component="div"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}
          >
            {selectMultiple ? (
              <Counter
                value={numOfVehicle}
                label="vehicle"
                btnMargin="0px"
                negativeOnClick={() =>
                  numOfVehicle > 0 ? handleVehicleCounter('negative') : null
                }
                positiveOnClick={() => handleVehicleCounter('positive')}
                positiveDisabled={!canSelectMoreCars}
              />
            ) : (
              <Button
                sx={{
                  backgroundColor: 'var(--jy-navy-900, #00253d)',
                  margin: 0,
                }}
                onClick={() => setOpenModal(true)}
                disabled={isLoadingBooking}
              >
                SELECT
              </Button>
            )}
          </Box>
        </Box>
      </Box>
      <VehicleDetailsModal
        data={{
          title: title || '',
          example: example || '',
          cardist: cardist || '',
          image: image || '',
          seats: seats || 0,
          luggage: luggage || 0,
          quotes: lowestPriceObject,
        }}
        isOneWay={data.plan?.journeyTypeName === JourneyType.ONE_WAY}
        isAsDirected={data.plan?.journeyTypeName === JourneyType.AS_DIRECTED}
        isImmediateJourney={isImmediateJourney}
        openModal={openModal}
        displayVATPrice={displayVATPrice}
        setOpenModal={setOpenModal}
        isFlexible={displayFlexible}
        numOfVehicle={numOfVehicle}
        setNumOfVehicle={setNumOfVehicle}
        handleBookCar={handleBookCar}
        selectedVehicles={selectedVehicles}
        setSelectedVehicles={setSelectedVehicles}
        client={client}
        travelPolicy={{
          locale: 'en-GB',
          precheck: (estimatedPrice: number) =>
            precheckWizardBooking({ estimatedPrice }),
          buildMessage: (decision, opts) => buildPolicyMessage(decision, opts),
          buildDialogText: (decision, opts) =>
            buildPolicyDialogText(decision, opts),
        }}
      />
    </>
  )
}

export default QuotesTitle
